import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request from '../../request'
import styles from '../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'


import { RightsWrapper } from '../../components/_utils/utils'
const TabPane = Tabs.TabPane
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
@Form.create()
class LoyalityMembers extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    universities: [],
    allUsers: [],
    countryCodes: []
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let response = await Request.getProgramMembers(params);
      this.setState({ total: response.total })
      resolve(response)
    })
  }


  handleSubmit = e => {
    const { form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateProgramMember(values);
        } else {
          x = await Request.addProgramMember(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0'
          })
          notification.success({
            message: this.state.id
              ? `Member Details Updated Successfully`
              : 'Member Details Added successfully'
          })
          if (!this.state.id) {
            form.setFieldsValue({
              referralType: '',
              credits: ''
            })
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.message
          })
        }
      }
    })
  }

  deleteProgramMember = async data => {
    this.setState({ loading: true })
    await Request.deleteProgramMember(data)
    this.setState({ loading: false })
    this.table.current.reload();
    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }

  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  getCountryCodes = async () => {
    let params = {
      results: 10000,
      count: 10000
    }
    let response = await Request.getCountriesWithoutAuth(params)
    let countryCodes = []
    _.each(response.data, (country) => {
      if (country.countryPhoneCode) {
        countryCodes.push({ _id: country.countryPhoneCode, display: country.countryPhoneCode });
      }
    })
    this.setState({ countryCodes })
  }


  setProgramMemberData(programMemberId) {
    if (programMemberId) {
      Request.getProgramMemberById({ id: programMemberId }).then(({ result, error, message }) => {
        if (!error && result) {
          this.setState({
            id: result._id,
            activeTab: '1'
          })
          let numbers = result.phone.split('-')

          this.props.form.setFieldsValue({
            name: result.name,
            countryCode: result.countryCode,
            phone: numbers[1],
            membershipCode: result.membershipCode,
            email: result.email ? result.email : ''
          })
        }
      })
    }
  }


  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  loadApis = async () => {
    let universityParams = {
      results: 10000,
      count: 10000
    }
    let universityResponse = await Request.getUniversities(universityParams)
    let universities = []
    _.each(universityResponse.data, (university) => {
      universities.push({ id: university._id, display: university.universityInstitutionName })
    })
    let usersParams = {
      sortField: '_id',
      sortOrder: 'ascend',
      results: 200,
      active: true,
      userType: { $ne: "Student" }
    }
    let userResponse = await Request.loadUser({ ...usersParams, regExFilters: ['name'] })
    let allUsers = []
    _.each(userResponse.data, (user) => {
      allUsers.push({ id: user._id, display: user.name })
    })
    this.setState({ universities, allUsers })
  }



  componentWillMount() {

  }

  async componentDidMount() {
    this.getCountryCodes()
    this.loadApis()
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }
  render() {
    const {
      form: { getFieldDecorator, setFieldsValue }
    } = this.props
    const { id, countryCodes } = this.state;

    const inputTypes = {
      fields: [
        {
          label: 'Member Name',
          key: 'name',
          required: true,
          type: 'text'
        },
        {
          label: 'Country Code',
          key: "countryCode",
          required: true,
          type: 'select',
          options: countryCodes,
          showSearch: true,
          onChange: v => {
            this.props.form.setFieldsValue({ countryCode: v })
          }
        },
        {
          label: 'Contact Number',
          key: 'phone',
          required: true,
          type: 'text'
        },
        {
          label: `Membership Code`,
          key: 'membershipCode',
          required: true,
          type: 'text',

        },
        {
          label: 'Email Address',
          key: 'email',
          type: 'text'
        }
      ]
    };

    const columns = [
      {
        title: 'S. No.',
        key: 'serialNumber',
        width: 60,
        render: (text, record, index) => (
          <div>{index + 1}</div>
        )
      },
      {
        title: 'Member Name',
        key: 'name',
        searchTextName: "Member Name",
        filterRegex: true
      },
      {
        title: 'Contact Number',
        key: 'phone',
        dataIndex: 'phone',
        searchTextName: "Contact Number",
        filterRegex: true
      },
      {
        title: 'Membership Code',
        key: 'membershipCode',
        searchTextName: "membershipCode",
        filterRegex: true
      },
      {
        title: 'Email Address',
        key: 'email',
        searchTextName: "Email Address",
        filterRegex: true
      },
      {
        title: 'Joining Date',
        key: 'joiningDate',
        render: (text, record) => (
          <div>{record && record.joiningDate ? moment(record.joiningDate).format(dateFormat) : "N/A"}</div>
        )
      },
      {
        title: 'Added By',
        key: 'createdByName',
        dataIndex: 'createdByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'loyalityProgramDetails.edit'}>
              <Tooltip title="Edit Program Member">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setProgramMemberData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'loyalityProgramDetails.delete'}>
              <Tooltip title="Delete Program Detail">
                <Popconfirm
                  title="Are you sure delete this Program Detail?"
                  onConfirm={() => {
                    this.deleteProgramMember({ _id: record._id })
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Program Members `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Members`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 900 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>

            <TabPane tab={(id ? 'Edit' : 'Add') + ' Member '} key={1}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default LoyalityMembers
